<template>
  <div class="xy-box">
    <div class="Gameheader">
      <div class="left">
        <span class="line"></span>
        <span class="title">{{ title }}</span>
      </div>
      <div class="right" @click="toRank">
        <span>更多</span>
        <van-icon name="arrow" class="right-icon" />
      </div>
    </div>
    <div class="rank">
      <div class="gameConetent">
        <div class="item" v-for="item in rankList" :key="item.id" @click="gotoGame(item.app_id)">
          <img :src="item.icon" alt="" />
          <div class="right">
            <div class="title">
              <h3>{{ item.app_name }}</h3>
              <!-- <p>近7日在线人数8888</p> -->
            </div>
            <div class="content" v-show="showIntro">
              <p v-html="replaceAll(item.intro)"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "gameContent",
    props: {
      icon: {
        type: String,
        value: "",
      },
      app_name: {
        type: String,
        value: "",
      },
      intro: {
        type: String,
        value: "",
      },
      order_amount: {
        type: String,
        value: "",
      },
      otype: {
        type: Number,
        value: "",
      },
      title: {
        type: String,
        value: ''
      },

    },
    data() {
      return {
        rankList: [],
        showIntro: true
      };
    },

    created() {},
    mounted() {
      this.getRankList();
    },
    methods: {
      replaceAll(str){
        if(str) {
          return str.replace(new RegExp('&nbsp;','g'),'');
        }else {
          return ''
        }
      },
      getRankList() {
        this.$Ajax("game/rank", {
          otype: this.otype
        }, "get").then((rs) => {
          if (rs.code === 200) {
            this.rankList = rs.data.list;
          }
        });
      },
      toRank() {
        this.$emit('goRank', this.otype)
      },
      gotoGame(app_id) {
        this.$router.push({
          name: 'detail',
          query: {
            app_id
          }
        })
      }
    },
  };
</script>

<style scoped lang="less">
  .xy-box {
    margin-bottom: 2rem;
  }
  .Gameheader {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 4rem;
    text-align: center;
    .left {
      margin-left: 1.5rem;
      text-align: center;
      display: flex;
      align-items: center;

      .line {
        display: inline-block;
        width: .2rem;
        height: 1.5rem;
        background-color: #ff625a;
        margin-right: 1rem;
        vertical-align: middle;
      }

      .title {
        font-size: 1.4rem;
        font-weight: 700;
      }
    }

    .right {
      margin-right: 1rem;
      color: #999;

      .right-icon {
        margin-left: .6rem;
      }
    }
  }

  .rank {
    width: 100%;
    // height: 20rem;
    border-radius: 0.8rem;
    display: flex;

    .gameConetent {
      width: 35rem;
      background: white;
      border-radius: 0.85rem;
      margin-right: 1rem;
      margin-left: 1rem;
      overflow-y: hidden;

      .item {
        width: 35rem;
        display: flex;
        align-items: center;
        padding: 1rem;

        img {
          width: 5rem;
          height: 5rem;
        }

        .right {
          margin-left: 1rem;
          width: 100%;

          .title {
            width: 100%;
            display: flex;
            align-items: center;
            margin-bottom: 0.5rem;
            h3 {
              // margin-right: .5rem;
              width: 100%;
            }

            p {
              width: 12.5rem;
              height: 2rem;
              padding-left: 0.5rem;
              display: flex;
              flex-wrap: wrap;
              background-color: #fe5544;
              color: white;
              text-align: center;
              line-height: 2rem;
              border-radius: 0.85rem;
            }
          }

          .content {
            img,
            .img,
            .image {
              display: none;
            }
            /deep/img,
            /deep/.img,
            /deep/.image {
              display: none;
            }
            p {
              color: #bebebe;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              img,
              .img,
              .image {
                display: none;
              }
              /deep/img,
              /deep/.img,
              /deep/.image {
                display: none;
              }
            }
          }
        }
      }
    }
  }
</style>